(() => {
  'use strict';
  const t = window.BCMJourneyText || {};
  function updateContext(form) {
    const urlInput = form.querySelector('[data-bcm-context-url]');
    if (!urlInput) return;
    const premium = document.querySelector('.bcm-pdp');
    const standard = document.querySelector('variant-selects[data-update-url="true"]');
    const variant = premium?.querySelector('[data-variant-id]') || standard?.closest('.thb-product-detail')?.querySelector('form[action*="/cart/add"] input[name="id"]');
    let selection = '';
    if (variant?.value && !variant.disabled) {
      selection = premium?.querySelector('[data-size]')?.textContent || standard?.options?.join(' / ') || '';
    }
    const options = form.querySelector('[data-bcm-context-options]');
    if (options) options.value = selection || t.confirm_selection;
    const url = new URL(urlInput.dataset.productUrl, location.origin);
    if (variant?.value && !variant.disabled) url.searchParams.set('variant', variant.value);
    urlInput.value = url.href;
    const supportInput = premium?.querySelector('[name="bcm-support"]:checked');
    const support = form.querySelector('[data-bcm-context-support]');
    if (support) {
      const height = premium?.querySelector('[name="bcm-foundation-height"]:checked')?.value || '';
      support.value = supportInput?.value === 'none' ? t.mattress_only : supportInput?.closest('label')?.querySelector('strong')?.textContent || t.confirm_support;
      if (supportInput?.value === 'foundation' && height) support.value += ` · ${height}`;
    }
    const summary = form.querySelector('[data-bcm-context-summary]');
    if (summary) summary.textContent = selection ? `${t.selected_options}: ${selection}` : t.confirm_selection;
  }
  function handoff() {
    if (location.pathname !== '/pages/contact-us') return;
    const body = document.querySelector('#bcm-contact-form [name="contact[body]"]');
    if (!body) return;
    try {
      const raw = sessionStorage.getItem('bcm.room-plan.handoff.v1');
      if (!raw) return;
      sessionStorage.removeItem('bcm.room-plan.handoff.v1');
      const plan = JSON.parse(raw);
      const age = Date.now() - plan.createdAt;
      if (typeof plan.text !== 'string' || plan.text.length > 12000 || !Number.isFinite(age) || age < 0 || age > 30 * 60 * 1000) return;
      body.maxLength = Math.max(body.maxLength, 16000);
      body.value = [body.value.trim(), plan.text].filter(Boolean).join('\n\n');
      const status = document.createElement('p'); status.setAttribute('role', 'status'); status.textContent = t.plan_ready; body.before(status);
    } catch {}
  }
  const init = () => { document.querySelectorAll('[data-bcm-contact-form]').forEach(updateContext); handoff(); };
  document.addEventListener('change', () => document.querySelectorAll('[data-bcm-contact-form]').forEach(updateContext));
  document.addEventListener('product:variant-change', () => document.querySelectorAll('[data-bcm-contact-form]').forEach(updateContext));
  document.addEventListener('submit', event => { if (event.target.matches('[data-bcm-contact-form]')) updateContext(event.target); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
